import { msalInstance } from '../index'
import { loginRequest } from '../authConfig'
import { v4 as uuidv4 } from 'uuid'

const DEFAULT_TIMEOUT_MS = 60000

const fetchWithTimeout = (url, options, timeoutMs = DEFAULT_TIMEOUT_MS) => {
  const controller = new AbortController()
  const timeoutId = setTimeout(() => controller.abort(), timeoutMs)
  return fetch(url, { ...options, signal: controller.signal }).finally(() => clearTimeout(timeoutId))
}

export const authHeader = async () => {
  const account = msalInstance.getActiveAccount()

  // Sin cuenta activa no hay token que pedir, y acquireTokenSilent lanzaría una excepción que tumba
  // la llamada antes de salir a la red. Pasa en la página de impresión de diseños, que se abre sin
  // sesión desde el generador de diseños: sus endpoints son anónimos y no necesitan cabecera.
  if (!account) {
    return ''
  }

  const request = {
    ...loginRequest,
    account,
  }

  let response = await msalInstance.acquireTokenSilent(request)

  const expiresInMs = response.expiresOn.getTime() - Date.now();

  // Si caduca pronto, forzar refresh
  const minutesBefore = 10
  if (expiresInMs < minutesBefore * 60 * 1000) {
    response = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account,
      forceRefresh: true
    });
    console.log('✅ Token renovado');
  }

  // const token = response.idToken;
  const token = response.accessToken

  const isLoggedIn = !!token

  if (isLoggedIn) {
    return `Bearer ${token}`
  }

  return ''
}


export const get = async (url, path) => {
  return fetchWithTimeout(url + path, {
    method: 'GET',
    headers: {
      Authorization: await authHeader(url),
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
}

export const post = async (url, path, body) => {
  const response = await fetchWithTimeout(url + path, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      Authorization: await authHeader(url),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  })
  if (response.status === 504) {
    const err = new Error('Tiempo de espera agotado')
    err.httpStatus = 504
    throw err
  }
  return response
}

export const postForm = async (url, path, form, timeoutMs = DEFAULT_TIMEOUT_MS) => {
  return fetchWithTimeout(
    url + path,
    {
      method: 'POST',
      body: form,
      headers: {
        Authorization: await authHeader(url),
      },
    },
    timeoutMs,
  )
}

export const putForm = async (url, path, form) => {
  return fetchWithTimeout(url + path, {
    method: 'PUT',
    body: form,
    headers: {
      Authorization: await authHeader(url),
    },
  })
}

export const patchForm = async (url, path, form) => {
  return fetchWithTimeout(url + path, {
    method: 'PATCH',
    body: form,
    headers: {
      Authorization: await authHeader(url),
    },
  })
}

export const put = async (url, path, body, xrequestid) => {
  return fetchWithTimeout(url + path, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      Authorization: await authHeader(url),
      'Content-Type': 'application/json',
      'x-requestid': xrequestid,
    },
    body: JSON.stringify(body),
  })
}

export const patch = async (url, path, body) => {
  return fetchWithTimeout(url + path, {
    method: 'PATCH',
    headers: {
      Accept: 'application/json',
      Authorization: await authHeader(url),
      'Content-Type': 'application/json',
      'x-requestid': uuidv4(),
    },
    body: JSON.stringify(body),
  })
}
export const jsonPatch = async (url, path, body) => {
  return fetchWithTimeout(url + path, {
    method: 'PATCH',
    headers: {
      Accept: 'application/json',
      Authorization: await authHeader(url),
      'Content-Type': 'application/json-patch+json',
      'x-requestid': uuidv4(),
    },
    body: JSON.stringify(body),
  })
}

export const remove = async (url, path, body) => {
  return fetchWithTimeout(url + path, {
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      Authorization: await authHeader(url),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body) ?? '',
  })
}




